var firstSellingPlanCheckbox = document.querySelector(".product-main__purchase-type input");
var allSellingPlansButtons = document.querySelectorAll(".custom-product-subscription-widget .selling-plan-inner");
var sellinsPlanContainer = document.querySelector(".selling-plans");
var currentPlanSelector = sellinsPlanContainer.querySelector(".current");
var sellingPlanOptionsSelect = sellinsPlanContainer.querySelector(".custom-product-subscription-widget select");
var sellingPlanOptions = sellinsPlanContainer.querySelectorAll(".custom-product-subscription-widget select option");
var urlParams = new URLSearchParams(window.location.search);
var selectedSellingPlan = urlParams.get("selling_plan");


allSellingPlansButtons.forEach(function (button) {
  button.addEventListener("click", function () {
    var quantitySelector = sellinsPlanContainer.querySelector(".quantity");
    var sellingPlanSelector = sellinsPlanContainer.querySelector(".nice-select");
    var buttonId = this.getAttribute("data-id");
    var selingPlanCheckboxes = document.querySelectorAll(".custom-product-subscription-widget .product-main__purchase-type input");
    var allSellingPlans = document.querySelectorAll(".custom-product-subscription-widget .selling-plan-wrapper");
    let sellingPlanEmulator;

    allSellingPlans.forEach(function (sellingPlan) {
      if (sellingPlan) {
        sellingPlan.classList.remove("selected");
        sellingPlan.querySelector(".selling-plan-inner").classList.remove("selected");
      }
    });

    this.classList.add("selected");
    this.closest(".selling-plan-wrapper").classList.add("selected");

    if (buttonId === "1" || !buttonId) {
      sellingPlanEmulator = document.getElementById("appstle_selling_plan_label_10");
    } else {
      sellingPlanEmulator = document.getElementById("appstle_selling_plan_label_20");
    }

    if (sellingPlanEmulator) {
       sellingPlanEmulator.click();
    }
  });
});

sellingPlanOptionsSelect.addEventListener("change", function (e) {
  var selectedOptionIndex = this.selectedIndex;
  var selectedOption = this[selectedOptionIndex]

  if (selectedOption) {
    var subscriptionAppEmulator = document.querySelector(".appstle_subscription_wrapper");
    var sellingPlan = document.querySelector(".product-main__purchase-type label[data-id='2'] input");
    var sellingPlanSelector = sellinsPlanContainer.querySelector(".nice-select");
    var optionId = selectedOption.getAttribute("data-value");
    var optionSalePrice = selectedOption.getAttribute("data-discounted-price");
    var selectedSellingPlan = document.querySelector(".custom-product-subscription-widget .selling-plan-inner.selected");
    var sellingPlanTotalPrice = selectedSellingPlan.querySelector(".price-item--sale");
  
    if (subscriptionAppEmulator) {
      var sellingPlanEmulatorOptions = subscriptionAppEmulator.querySelectorAll(".appstleRadioSellingPlanWrapper input[type='radio']");
  
      var emulatorOption = [...sellingPlanEmulatorOptions].filter((emulatorOption) => emulatorOption.getAttribute("value") === optionId);
  
      if (emulatorOption.length) {
        emulatorOption[0].click();
      }

      if (sellingPlanTotalPrice) {
        sellingPlanTotalPrice.innerHTML = optionSalePrice;
      }
    }
  }
});

document.addEventListener("customVariantChanged", function (event) {
  var productData = event.detail;

  if (productData) {
    var subscriptionWidget = document.querySelector(".custom-product-subscription-widget");
    var priceElement = subscriptionWidget.querySelector(".subscription-price");
    var priceRegularElement = subscriptionWidget.querySelector(".price-item.price-item--regular");
    var priceSaleElement = subscriptionWidget.querySelector(".price-item.price-item--sale");
    var selectedSellingPlanSelect = subscriptionWidget.querySelector(".nice-select select");
    var selectedOption = selectedSellingPlanSelect.options[selectedSellingPlanSelect.selectedIndex];
    var selectedOptionPlanID = selectedOption.getAttribute("data-value");

    if (selectedOptionPlanID && productData.selling_plan_allocations && productData.selling_plan_allocations.length) {
      var selectedOptionData = productData.selling_plan_allocations.filter((allocation) => (allocation.selling_plan_id + "") === selectedOptionPlanID);

       if (priceSaleElement && selectedOptionData[0]) {
        priceSaleElement.innerHTML = "&#8364;" + (selectedOptionData[0].price / 100).toFixed(2).replace(".", ",");
      }
    }

    if (priceElement) {
      priceElement.innerHTML = "&#8364;" + (productData.price / 100).toFixed(2).replace(".", ",");
    }

    if (priceRegularElement) {
      priceRegularElement.innerHTML = "&#8364;" + (productData.price / 100).toFixed(2).replace(".", ",");
    }
  
    if (subscriptionWidget) {
      var firstSubscriptionOption = subscriptionWidget.querySelector(".selling-plan-inner");
  
      if (firstSubscriptionOption) {
        firstSubscriptionOption.click();
      }
    }
  }
});

if (selectedSellingPlan && allSellingPlansButtons.length) {
  var activeSellingPlan = allSellingPlansButtons[allSellingPlansButtons.length - 1];

  if (activeSellingPlan) {
    var activeSellingPlanOption = [...sellingPlanOptions].filter((option) => option.getAttribute("data-value") === selectedSellingPlan);

    if (activeSellingPlanOption.length) {
      setTimeout(function () {
        activeSellingPlan.click();
        document.getElementById("appstle_selling_plan_label_20").click();

        if (activeSellingPlanOption[0]) {
          activeSellingPlanOption[0].selected = true;
  
          var sellingPlanPriceEl = document.querySelector(".custom-product-subscription-widget .price-item--sale.subscription-price");
          var optionSellingPlanPrice = activeSellingPlanOption[0].getAttribute("data-discounted-price");
  
          if (optionSellingPlanPrice && sellingPlanPriceEl) {
            sellingPlanPriceEl.innerHTML = optionSellingPlanPrice
          }
        }
      }, 300)
    }
  }
}